import { Cancel } from '@mui/icons-material'
import { MenuItem } from '@mui/material'
import { ActionsItemProps } from './actions'
import { useLostProposalModalStore } from 'modules/orders/components/LostProposalModal'

export const LostProposal = ({ order, disabled }: ActionsItemProps) => {
  const setModalOpen = useLostProposalModalStore.useSetModalIsOpen()
  const setProposalId = useLostProposalModalStore.useSetProposalId()

  const handleLostProposal = () => {
    setModalOpen(true)
    setProposalId(order.proposalId)
  }

  return (
    <>
      <MenuItem disabled={disabled} onClick={handleLostProposal} disableRipple>
        <Cancel />
        Cancelar Orçamento
      </MenuItem>
    </>
  )
}
